import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  IconButton
} from "@mui/material";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import PersonIcon from "@mui/icons-material/Person";
import HelpSupportPopup from "../Components/HelpandSupport/Help-or-Machine/HelpSupportPopup";
import { useSelector } from "react-redux";
import NewBadge from "./NewBadge";

const BottomNavBar = () => {
  const [showHelpPopup, setShowHelpPopup] = useState(true);
  const [showNewBadge, setShowNewBadge] = useState(true);

  const ReduxBottomData = useSelector(
    (state) => state.WebSocket?.BottomData
  );

  const navigate = useNavigate();
  const { pathname } = useLocation();

  // 🔹 Hide popup if redux says so
  useEffect(() => {
    if (ReduxBottomData?.HelpSupportPopup) {
      setShowHelpPopup(false);
    }
  }, [ReduxBottomData]);

  // 🔹 Check NEW badge flag
  useEffect(() => {
    const seen = localStorage.getItem("supportNewSeen");
    if (seen) setShowNewBadge(false);
  }, []);

  const navItems = [
    { label: "Home", path: "/", icon: <HomeIcon /> },
    { label: "Orders", path: "/orders", icon: <ShoppingBagIcon /> },
    { label: "Profile", path: "/profile", icon: <PersonIcon /> },
    {
      label: "Support",
      path: "/help&support",
      icon: <HeadsetMicIcon />,
      isSupport: true
    }
  ];

  // 🔹 ACTIVE CHECK (Support included)
  const isActive = (item) => {
    if (item.isSupport) {
      return pathname.toLowerCase().includes("help&support");
    }
    return pathname === item.path;
  };

  // 🔹 Click handler
  const handleNavClick = (item) => {
    if (item.isSupport) {
      setShowHelpPopup(true);
      setShowNewBadge(false);
      localStorage.setItem("supportNewSeen", true);
      localStorage.setItem("helpsupportFlag", true);
      navigate("/help&support"); // ✅ SAME CASE
      return;
    }
    navigate(item.path);
  };

  return (
    <>
      {/* 🔹 Help & Support Popup */}
      {showHelpPopup && (
        <HelpSupportPopup
          onClose={() => {
            setShowHelpPopup(false);
            localStorage.setItem("helpsupportFlag", "true");
          }}
        />
      )}

      {/* 🔹 Bottom Navigation */}
      <Paper
        elevation={12}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          borderRadius: "24px 24px 0 0",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          background: "#fff",
          zIndex: 999999,
          height: "80px"
        }}
      >
        {navItems.map((item) => (
          <Box
            key={item.label}
            onClick={() => handleNavClick(item)}
            sx={{
              flex: 1,
              textAlign: "center",
              cursor: "pointer",
              backgroundColor:
                item.isSupport && showHelpPopup ? "#FFD54F" : "transparent",
              width: item.isSupport ? "60px" : "auto",
              height: item.isSupport ? "60px" : "auto",
              borderRadius: item.isSupport ? "60px" : "0px"
            }}
          >
            {!showHelpPopup && item.isSupport && <NewBadge />}

            <IconButton disableRipple style={{padding:5}}>
              <Box
                sx={{
                  color: isActive(item) ? "#583C43" : "#718198",
                  transition: "0.3s",
                  p:0
                }}
              >
                {item.icon}
              </Box>
            </IconButton>

            <Typography
              sx={{
                fontSize: 12,
                marginTop: "-6px",
                color: isActive(item) ? "#583C43" : "#718198",
                p:0
              }}
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Paper>
    </>
  );
};

export default BottomNavBar;
